import CalendarPage from "@/client/components/pages/Calendar";

export default CalendarPage;
